module.exports = __webpack_public_path__ + "img/1509380241.be894d11.jpg";